var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"gallery-thumb-item flex-shrink-0 transition-all transision-200 relative cursor-pointer",class:{'border-4 border-gold-500': _vm.isActive},on:{"click":_vm.clicked}},[_c('img',{staticClass:"cursor-pointer",attrs:{"src":_vm.thumbnailUrl,"alt":_vm.alt,"width":"100","height":"69"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }